"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.properties = void 0;
const tslib_1 = require("tslib");
require("@progress/kendo-ui");
require("babel-polyfill");
require("jquery-ui-bundle");
require("jquery-ui-bundle/jquery-ui.css");
require("jquery-address");
const SelectionContext_1 = require("../../../TdWebtoolkitControls/controls/Menu/SelectionContext");
require("../../../TdWebtoolkitControls/controls/Preview/Preview");
require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const PropertyPage_1 = require("../../../TdWebtoolkitControls/controls/PropertyPage/PropertyPage");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const Base_1 = require("../../../TdWebtoolkitControls/model/Base");
const ModificationInfo_1 = require("../../../TdWebtoolkitControls/model/ModificationInfo");
const $ = require("jquery");
const m = require("../SynView");
const PushClient_1 = require("../../../TdWebtoolkitControls/model/PushClient");
const PushEvent_1 = require("../../../TdWebtoolkitControls/model/PushEvent");
class properties extends m.SynView {
    constructor() {
        super();
        this.m_subsciption = [];
        this.m_externalChangeEventRegistered = false;
    }
    //#region MEMBER METHODS
    //#region Inherited from SynView
    init(viewName, viewIndex, viewHtml) {
        super.init(viewName, viewIndex, viewHtml);
    }
    activate() {
        super.activate();
        if (this.m_id) {
            Utilities_1.synUtil.getInstance(this.m_id, (instance) => {
                if (instance)
                    document.title = instance.items["cgdoctype.name"].valueAsString + ": " + instance.name.valueAsString;
            });
        }
    }
    deactivate() {
        this.unregisterChangeWebsocket();
        Utilities_1.synUtil.Notifications.remove(this.m_notificationGUID);
        super.deactivate();
    }
    onWindowFocus() {
    }
    disableUI(disable = true) {
        const that = this;
        super.disableUI(disable);
        if (disable)
            that.m_$tabs.find(".k-tabstrip-items > .k-item").attr("disabled", "disabled").addClass("k-state-disabled");
        else
            that.m_$tabs.find(".k-tabstrip-items > .k-item").removeAttr("disabled").removeClass("k-state-disabled");
    }
    setURL() {
        const that = this;
        if (!that.IsActiveView || typeof that.m_id === "undefined")
            return;
        $.address.autoUpdate(false);
        $.address.parameter("id", that.m_id, false);
        $.address.parameter("relid", that.m_relId ? that.m_relId.toString() : "", false);
        $.address.update();
        $.address.autoUpdate(true);
    }
    getSelectionContext() {
        if (!this.m_$tabs.synTabs("isInitialized"))
            return super.getSelectionContext();
        else {
            let parentControl = false;
            let selectedIds = [];
            let normalParentContext = {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            };
            let parentControlParentContext = {
                parentRelId: SelectionContext_1.SpecialRelIds.Undefined
            };
            let version = undefined;
            if (this.m_$tabs.synTabs("currentTabIsPropertyTab")) {
                parentControlParentContext.parentId = this.m_id;
                parentControlParentContext.parentRelId = SelectionContext_1.SpecialRelIds.All;
                parentControl = true;
                selectedIds = [this.m_id];
                version = this.m_$tabs.synTabs("getPropertyPage").synPropertyPage("getVersion");
            }
            else {
                normalParentContext.parentId = this.m_id;
                normalParentContext.parentRelId = this.m_$tabs.synTabs("getSelectedRelId");
                selectedIds = this.m_$tabs.synTabs("getSelectedIds");
            }
            return {
                parentControl,
                normalParentContext,
                parentControlParentContext,
                selectedIds,
                version
            };
        }
    }
    getParametersFromUrl() {
        const that = this;
        const oldId = that.m_id;
        super.getParametersFromUrl();
        if (typeof oldId !== "undefined" && oldId != that.m_id) {
            that.m_$tabs.synTabs("setParentAsync", that.m_id, this.m_relId || "PropertyRel", undefined, true)
                .then(() => {
                if (that.m_$tabs.synTabs("currentTabIsPropertyTab"))
                    that.m_$preview.synPreview("setInstanceAsync", that.m_id);
                else
                    that.m_$preview.synPreview("clearView");
                that.setInstance();
            });
        }
    }
    registerChangeWebsocket() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            if (this.m_subsciption) {
                for (let sub of that.m_subsciption)
                    PushClient_1.PushClient.RemoveEventHandler(sub);
                that.m_subsciption.splice(0);
            }
            let eventHandler = (event) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    if (event instanceof PushEvent_1.DocumentEvent) {
                        let dEvent = event;
                        let propertyPage = that.m_$tabs.synTabs("getPropertyPage");
                        let docId = that.m_id.split("|")[1];
                        let etag = dEvent.Etag;
                        if (etag && that.m_eTag !== etag && !that.m_saveInProgress) {
                            if (propertyPage.synPropertyPage("instanceHasChanged")) {
                                propertyPage.synPropertyPage("lock");
                                that.disableUI(false);
                                Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
                                let confirmObj = Utilities_1.synUtil.Notifications.warningConfirm(Utilities_1.synUtil.Strings.getValue("syndocumentchangedwhileediting"));
                                Utilities_1.synUtil.Notifications.getNotificationElem(confirmObj.notificationGuid).css("bottom", "0");
                                yield confirmObj.confirmResult;
                                that.m_eTag = etag;
                                propertyPage.synPropertyPage("deleteUnsavedChanges");
                                propertyPage.synPropertyPage("refresh", true);
                                that.m_$preview.synPreview("recreateAsync");
                            }
                            else {
                                that.m_eTag = etag;
                                Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
                                that.m_notificationGUID = Utilities_1.synUtil.Notifications.info(Utilities_1.synUtil.Strings.getValue("syndocumentchanged"));
                                propertyPage.synPropertyPage("refresh");
                                that.m_$preview.synPreview("recreateAsync");
                            }
                        }
                    }
                }
                catch (e) {
                }
            });
            this.m_subsciption.push(yield PushClient_1.PushClient.AddDocumentChangedEventHandler(eventHandler, Number.parseInt(that.m_id.split("|")[1])));
            this.m_subsciption.push(yield PushClient_1.PushClient.AddDocumentDeletedEventHandler(eventHandler, Number.parseInt(that.m_id.split("|")[1])));
        });
    }
    unregisterChangeWebsocket() {
        const that = this;
        if (that.m_subsciption) {
            for (let sub of that.m_subsciption)
                PushClient_1.PushClient.RemoveEventHandler(sub);
            that.m_subsciption.splice(0);
        }
    }
    setInstance() {
        const that = this;
        const instance = that.m_$tabs
            .synTabs("getPropertyPage")
            .synPropertyPage("getInstance");
        if (instance) {
            that.m_eTag = instance.items["cgdocument.etag"].valueAsString;
            document.title = instance.items["cgdoctype.name"].valueAsString + ": " + instance.name.valueAsString;
            that.raiseOnViewHistory(instance.id.valueAsString, instance.name.valueAsString, true);
            that.registerChangeWebsocket();
        }
        else
            that.unregisterChangeWebsocket();
        this.updateSelectionContext();
        window.waitConditions.set("propertyPageReady.properties");
    }
    renderContents() {
        const that = this;
        that.m_$preview = that.m_$container.find("#Preview");
        that.m_$tabs = $("#Tabs");
        let paramRelId = undefined;
        let relIdTmp = $.address.parameter("relid");
        if (relIdTmp)
            paramRelId = parseInt(relIdTmp, 10);
        that.m_$tabs
            .on("selectionChanged", (evt, _parentId, _relId, ids) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (ids.length === 1)
                yield that.m_$preview.synPreview("setInstanceAsync", ids[0]);
            else
                that.m_$preview.synPreview("clearView");
            that.updateSelectionContext();
        }))
            .on("propertyPageVersionChanged", (evt, versionOpts) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            let id = versionOpts.id;
            if (!versionOpts.verCur)
                id += "|" + versionOpts.version.toString();
            yield that.m_$preview.synPreview("setInstanceAsync", id);
            that.updateSelectionContext();
        }))
            .on("tabSelected", (_evt, _parentId, relId, isPropertyTab) => tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (isPropertyTab) {
                that.m_relId = undefined;
                yield that.m_$preview.synPreview("setInstanceAsync", that.m_id);
            }
            else {
                that.m_relId = relId;
                const selectedIds = that.m_$tabs.synTabs("getSelectedIds");
                if (selectedIds.length === 1)
                    yield that.m_$preview.synPreview("setInstanceAsync", selectedIds[0]);
                else
                    that.m_$preview.synPreview("clearView");
            }
            that.setURL();
            that.updateSelectionContext();
        }))
            .on("propertyPageValuesChanged", () => {
            that.askSaveChanges(false, (saveResult) => {
                that.m_$tabs.synTabs("getPropertyPage").synPropertyPage("deleteUnsavedChanges");
                if (saveResult === m.ViewSaveResult.Save && !that.m_saveInProgress) {
                    that.m_saveInProgress = true;
                    Utilities_1.synUtil.beginAjaxProgress(".changeBar .btn.save");
                    that.m_$tabs.synTabs("getPropertyPage").synPropertyPage("commitChanges", {
                        success(currentInstance, commitResult) {
                            that.m_eTag = currentInstance.items["cgdocument.etag"].valueAsString;
                            switch (commitResult) {
                                case PropertyPage_1.CommitSuccess.Saved:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savedchanges"));
                                    that.m_$preview.synPreview("recreateAsync");
                                    that.CommandTriggerTarget.trigger("forceRefresh", [{
                                            fullRefreshNecessary: false,
                                            modifiedInstances: [currentInstance]
                                        }]);
                                    break;
                                case PropertyPage_1.CommitSuccess.Created:
                                    Utilities_1.synUtil.Notifications.success(Utilities_1.synUtil.Strings.getValue("savednew"));
                                    that.raiseOnViewMadeChanges();
                                    break;
                                case PropertyPage_1.CommitSuccess.NoChanges:
                                    Utilities_1.synUtil.Notifications.warning(Utilities_1.synUtil.Strings.getValue("nochanges"));
                                    break;
                                default:
                                    break;
                            }
                            that.m_saveInProgress = false;
                            that.disableUI(false);
                        },
                        cleanUp() {
                            that.m_saveInProgress = false;
                            Utilities_1.synUtil.endAjaxProgress(".changeBar .btn.save");
                        },
                        updatePropertyPageAfterCommit: true
                    });
                }
                else if (saveResult === m.ViewSaveResult.Cancel) {
                    that.m_$tabs.synTabs("getPropertyPage").synPropertyPage("refresh");
                    that.disableUI(false);
                }
            });
        })
            .on("propertyPageValuesReverted", function (event) {
            that.disableUI(false);
        })
            .on("propertyPageUnsavedChangesObsolete", function (event, eTag) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                let $propPage = that.m_$tabs.synTabs("getPropertyPage");
                $propPage.synPropertyPage("lock");
                that.disableUI(false);
                Utilities_1.synUtil.Notifications.remove(that.m_notificationGUID);
                let confirmObj = Utilities_1.synUtil.Notifications.warningConfirm(Utilities_1.synUtil.Strings.getValue("syndocumentchangedwhileediting"));
                Utilities_1.synUtil.Notifications.getNotificationElem(confirmObj.notificationGuid).css("bottom", "0");
                yield confirmObj.confirmResult;
                that.m_$tabs.synTabs("getPropertyPage").synPropertyPage("deleteUnsavedChanges");
                that.m_eTag = eTag;
                $propPage.synPropertyPage("refresh");
                that.m_$preview.synPreview("recreateAsync");
            });
        })
            .synTabs({
            windowName: "propertyeditormainframe",
            propertyPageMode: Base_1.PropertyPageMode.Edit,
            propertyPageCheckForUnsavedChanges: true,
            parentContext: {
                parentId: that.m_id,
                parentRelId: that.m_relId || "PropertyRel"
            },
            allowDragDrop: true
        }, true)
            .then(() => {
            that.updateSelectionContext();
            that.setInstance();
            that.m_$preview.synPreview({
                id: that.m_$tabs.synTabs("currentTabIsPropertyTab") ? that.m_id : undefined,
                editable: false
            });
            if (!this.m_externalChangeEventRegistered) {
                this.m_externalChangeEventRegistered = true;
                $.address.externalChange((evt) => {
                    if (evt.value === "/properties" || evt.value.indexOf("/properties?") === 0) {
                        this.getParametersFromUrl();
                        that.m_$tabs.synTabs("trySelectTab", this.m_relId || "PropertyRel");
                        that.updateSelectionContext();
                    }
                });
            }
        });
    }
    forceRefresh(modificationInfo) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const that = this;
            let fullRefresh = false;
            if (!modificationInfo)
                fullRefresh = true;
            else {
                if (modificationInfo.fullRefreshNecessary)
                    fullRefresh = true;
                else {
                    if (modificationInfo.modifiedInstances) {
                        that.m_$tabs.synTabs("update", modificationInfo.modifiedInstances);
                        that.m_$preview.synPreview("update", modificationInfo.modifiedInstances);
                    }
                    else if (modificationInfo.deletions) {
                        if (modificationInfo.deletions.action === ModificationInfo_1.ModificationAction.Object) {
                            const tabParentId = that.m_$tabs.synTabs("getParentId");
                            if (modificationInfo.deletions.instances.findIndex(delInst => delInst.id.valueAsString === tabParentId) >= 0) {
                                that.m_$tabs.synTabs("destroy");
                                that.m_$preview.synPreview("destroy");
                                this.updateSelectionContext();
                            }
                            else {
                                that.m_$preview.synPreview("delete", modificationInfo.deletions.instances);
                                yield that.m_$tabs.synTabs("delete", modificationInfo.deletions.instances);
                            }
                        }
                        else if (modificationInfo.deletions.action === ModificationInfo_1.ModificationAction.Link && modificationInfo.deletions.parent) {
                            that.m_$preview.synPreview("delete", modificationInfo.deletions.instances);
                            yield that.m_$tabs.synTabs("unlinkAsync", modificationInfo.deletions.instances, modificationInfo.deletions.parent, modificationInfo.deletions.relation);
                        }
                    }
                    else if (modificationInfo.new)
                        yield that.m_$tabs.synTabs("linkAsync", modificationInfo.new.instances, modificationInfo.new.parent, modificationInfo.new.relation);
                }
            }
            if (fullRefresh) {
                that.m_$tabs.synTabs("refreshCurrentTab");
                yield that.m_$preview.synPreview("recreateAsync");
            }
        });
    }
}
exports.properties = properties;
